'use client';

import a__default, { forwardRef } from "react";
import b from "../lib/IconBase.js";
import t$1 from "../defs/Plus.js";
var f = Object.defineProperty, i = Object.defineProperties;
var p = Object.getOwnPropertyDescriptors;
var t = Object.getOwnPropertySymbols;
var c = Object.prototype.hasOwnProperty, l = Object.prototype.propertyIsEnumerable;
var m = (o, e, r) => e in o ? f(o, e, { enumerable: true, configurable: true, writable: true, value: r }) : o[e] = r, a = (o, e) => {
  for (var r in e || (e = {}))
    c.call(e, r) && m(o, r, e[r]);
  if (t)
    for (var r of t(e))
      l.call(e, r) && m(o, r, e[r]);
  return o;
}, s = (o, e) => i(o, p(e));
const I = forwardRef((o, e) => /* @__PURE__ */ a__default.createElement(b, s(a({ ref: e }, o), { weights: t$1 })));
I.displayName = "Plus";
export {
  I as Plus
};
